import { Location } from '@angular/common'
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { FilterPropertyType } from '../../types/filter.type'

@Component({
  selector: 'bmcore-style-mood-selection-block',
  templateUrl: './bmcore-style-mood-selection-block.component.html',
  styleUrls: ['./bmcore-style-mood-selection-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreStyleMoodSelectionBlockComponent implements OnInit {
  url = ''
  styleId: number | string | null = null // string only for 'all' value
  moodId: number | string | null = null // string only for 'all' value

  constructor(private location: Location) {}

  ngOnInit(): void {}

  filterTracks(value: FilterPropertyType) {
    switch (value.title) {
      case 'style':
        this.styleId = value.id
        break
      case 'mood':
        this.moodId = value.id
        break
    }
    this.refreshUrl()
  }

  refreshUrl() {
    const url = `catalog/${this.checkStyle()}/${this.checkMood()}`

    // if styleId and moodId === 'all' => then delete 'all' from uri params
    this.url = url === 'catalog/all/all' ? 'catalog' : url
    this.location.replaceState(this.url)
  }

  checkStyle() {
    return this.styleId ? this.styleId : 'all'
  }

  checkMood() {
    return this.moodId ? this.moodId : 'all'
  }
}
